import * as _ from 'lodash';
import api from '../../../../../configurations/service';
import * as types from './mutation-types';

export const setFreightCollection = async (context) => {
  const { data } = await api().postWithCache('fiscal.get-frete');
  context.commit(types.SET_FREIGHT_COLLECTION, _.orderBy(data, 'id'));
};
